<template>
  <AddWatchListForm
    ref="updateWatchlist"
    :autoExecution="autoExecution"
    :isUpdating="true"
    :clientCodes="clientCodes"
    :allStocks="allStocks"
    @submitForm="updateWatchlistData($event)"
  />
  <DeleteDialog ref="deleteStock" @refresh="$emit('refresh')" />
  <q-table
    bordered
    :class="
      $q.dark.mode
        ? 'table-sticky-header-column-plane-dark-mode shadow-0'
        : 'table-sticky-header-column-plane shadow-0'
    "
    dense
    :rows="userStocks"
    :columns="userStocksColumn"
  >
    <template v-slot:header="props">
      <q-tr :props="props">
        <q-th v-for="col in props.cols" :key="col.name" :props="props">
          <div class="text-center">
            {{ col.label }}
          </div>
        </q-th>
        <q-th auto-width>
          <div class="text-center">Actions</div>
        </q-th>
      </q-tr>
    </template>
    <template v-slot:body="props">
      <tr>
        <q-td v-for="col in props.cols" :key="col.name" :props="props">
          {{ col.value }}
        </q-td>
        <q-td>
          <q-btn @click="showing = props.key" unelevated round icon="edit">
            <q-popup-proxy>
              <q-bar class="bg-white row ellipsis justify-center padding-0">
                <div class="text-bold q-gutter-xs">
                  <q-btn
                    v-if="autoExecution"
                    class="text-white"
                    color="primary"
                    size="sm"
                    no-caps
                    label="Update"
                    @click="updateWatchlist.openDialog(props.row)"
                  >
                    <q-tooltip class="text-primary bg-white">Update</q-tooltip>
                  </q-btn>
                  <q-btn
                    class="text-white"
                    color="negative"
                    size="sm"
                    no-caps
                    label="Delete"
                    @click="deleteThisStock(props.row)"
                  >
                    <q-tooltip class="text-primary bg-white">Delete</q-tooltip>
                  </q-btn>

                  <q-space />
                </div>
              </q-bar>
            </q-popup-proxy>
          </q-btn>
        </q-td>
      </tr>
    </template>
  </q-table>
</template>

<script setup>
import { ref } from "vue";
import { useQuasar } from "quasar";
import AddWatchListForm from "./AddWatchListForm.vue";
import useTms from "src/use/tms.js";
import DeleteDialog from "../DeleteDialog.vue";

const { patchWatchlist, deleteWatchlist } = useTms();
const $q = useQuasar();
const emit = defineEmits(["update", "delete"]);
const deleteStock = ref(null);
const props = defineProps({
  userStocks: {
    type: Array,
  },
  clientCodes: {
    type: Array,
  },
  allStocks: {
    type: Array,
  },
  autoExecution: {
    type: Boolean,
    default: false,
  },
});
const updateWatchlist = ref(null);

const updateWatchlistData = (data) => {
  data.client_id = props.clientCodes.find(
    (i) => i.client_code == data.client_code
  ).id;
  let dataCopy = JSON.parse(JSON.stringify(data));
  delete data.client_code;
  patchWatchlist(data)
    .then((res) => {
      res["client"] = dataCopy.client_code;
      res["id"] = dataCopy.id;
      emit("update", res);
      $q.notify({
        message: "Stock Updated",
        type: "positive",
      });
    })
    .catch((e) => {
      const { buy_target, symbol, message } = e.response.data;
      let err = buy_target || symbol || message;
      if (err) {
        $q.notify({
          message: buy_target?.[0] || symbol?.[0] || message[0],
          type: "negative",
        });
      } else {
        $q.notify({
          message: "Something went wrong",
          type: "negative",
        });
      }
    });
};

function deleteThisStock(data) {
  data["client_id"] = props.clientCodes.find(
    (i) => i.client_code == data.client
  ).id;
  delete data.client_code;
  deleteStock.value.openDialog().then((res) => {
    if (res === "y")
      deleteWatchlist(data).then(() => {
        emit("delete", data);
        $q.notify({
          message: "Stock Deleted",
          type: "positive",
        });
      });
  });
}

const userStocksColumn = ref([
  {
    name: "symbol",
    label: "Symbol",
    field: "symbol",
    align: "center",
  },
  {
    name: "client",
    label: "Client Code",
    field: "client",
    align: "center",
  },
]);
const updateTable = () => {
  if (props.autoExecution && props.userStocks.length > 0) {
    let buyTable = props.userStocks.some((i) => i.buy_target !== null);
    let sellTable = props.userStocks.some((i) => i.sell_target !== null);
    userStocksColumn.value.push({
      name: "quantity",
      label: "Quantity",
      field: "quantity",
      align: "center",
    });
    if (buyTable)
      userStocksColumn.value.push({
        name: "buy_target",
        label: "Buy Target",
        field: "buy_target",
        align: "center",
      });
    if (sellTable)
      userStocksColumn.value.push({
        name: "sell_target",
        label: "Sell Target",
        field: "sell_target",
        align: "center",
      });
  }
};
updateTable();
</script>
